module.exports = __webpack_public_path__ + "static/media/400397_01.ce5b67dd.png";